import { render, staticRenderFns } from "./gantChartt.vue?vue&type=template&id=48ad7f29&scoped=true&"
import script from "./gantChartt.vue?vue&type=script&lang=ts&"
export * from "./gantChartt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad7f29",
  null
  
)

export default component.exports